app.service('NotificationAPI', ['$http', 'ENV', 'Session', function ($http, ENV, Session) {

	var service = {
		isProcessing: false,

		getAvailableNotifications: function (data) {
			return $http({
				method: "GET",
				url: ENV.API + `/api/notification`,
				headers: {
					Authorization: "Bearer " + Session.token,
				},
			});
		},
		createNotification: function (data) {
			return $http({
				method: "POST",
				url: ENV.API + `/api/notification`,
				headers: {
					Authorization: "Bearer " + Session.token,
				},
				data: { ...data },
			});
		},
		getNotification: function (notificationId) {
			return $http({
				method: "GET",
				url: ENV.API + `/api/notification/${notificationId}`,
				headers: {
					Authorization: "Bearer " + Session.token,
				},
			});
		},
		updateNotificationActiveStatus: function (notificationId) {
			return $http({
				method: "PUT",
				url: ENV.API + `/api/notification/${notificationId}/active`,
				headers: {
					Authorization: "Bearer " + Session.token,
				},
			});
		},
		setNotificationViewedByUser: function (notificationId, userId) {
			return $http({
				method: "PUT",
				url: ENV.API + `/api/notification/${notificationId}/user/${userId}`,
				headers: {
					Authorization: "Bearer " + Session.token,
				},
			});
		},
		getPendingNotificationsForUser: function (userId) {
			return $http({
				method: "GET",
				url: ENV.API + `/api/notification/user/${userId}`,
				headers: {
					Authorization: "Bearer " + Session.token,
				},
			});
		},
	};

	return service;
}])
